import React from 'react';

const Giveaway = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      {/* Hero Section */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        padding: '60px 20px',
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        color: 'white',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '25px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          🎊 Giveaway Wheel Spinner - Fair Contest Tool
        </h1>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          opacity: '0.95',
          maxWidth: '900px',
          margin: '0 auto 35px'
        }}>
          Host transparent and exciting giveaways with our <strong>random winner picker</strong>. Perfect for streamers, businesses, and event organizers who need fair contest results.
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#f5576c',
            padding: '18px 40px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.3)'
          }}
        >
          Start Free Giveaway Spinner 🚀
        </a>
      </div>

      {/* Why Choose Section */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎯 Why Use Our Giveaway Wheel Spinner?
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '35px'
        }}>
          <div style={{
            textAlign: 'center',
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#f8f9fa'
          }}>
            <div style={{
              fontSize: '60px',
              marginBottom: '20px'
            }}>🎲</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '15px'
            }}>
              100% Fair & Random
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Our <strong>random winner picker</strong> uses true randomization algorithms to ensure completely unbiased results every time.
            </p>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#f8f9fa'
          }}>
            <div style={{
              fontSize: '60px',
              marginBottom: '20px'
            }}>👁️</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '15px'
            }}>
              Complete Transparency
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Live spinning animation shows your audience the exact moment of selection, building trust in your <strong>contest wheel spinner</strong>.
            </p>
          </div>

          <div style={{
            textAlign: 'center',
            padding: '30px',
            borderRadius: '15px',
            backgroundColor: '#f8f9fa'
          }}>
            <div style={{
              fontSize: '60px',
              marginBottom: '20px'
            }}>⚡</div>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '15px'
            }}>
              Instant Setup
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              No complex software or downloads needed. Start your <strong>giveaway spinner online</strong> in seconds with any device.
            </p>
          </div>
        </div>
      </div>

      {/* Use Cases */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '50px',
        borderRadius: '15px',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎪 Perfect for Every Type of Giveaway
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '20px'
            }}>
              📺 Live Streaming Events
            </h3>
            <p style={{ marginBottom: '20px', fontSize: '16px' }}>
              Engage your Twitch, YouTube, or Facebook audience with live <strong>streamer giveaway wheels</strong>.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Subscriber milestone celebrations
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Follow goal rewards and contests
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Interactive viewer engagement games
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Charity fundraising prize draws
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '20px'
            }}>
              🏢 Business Promotions
            </h3>
            <p style={{ marginBottom: '20px', fontSize: '16px' }}>
              Boost engagement and attract customers with professional <strong>business giveaway tools</strong>.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Social media contest campaigns
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Trade show and event prizes
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Customer loyalty program draws
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Grand opening and anniversary events
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '20px'
            }}>
              🎉 Special Events
            </h3>
            <p style={{ marginBottom: '20px', fontSize: '16px' }}>
              Make any celebration memorable with our <strong>event prize wheel spinner</strong>.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Wedding reception entertainment
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Birthday party prize drawings
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Corporate team building events
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Fundraising galas and auctions
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f5576c',
              marginBottom: '20px'
            }}>
              🌐 Online Communities
            </h3>
            <p style={{ marginBottom: '20px', fontSize: '16px' }}>
              Build community engagement with fair <strong>online raffle wheels</strong> and contests.
            </p>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Discord server member rewards
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Facebook group engagement contests
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Reddit community prize draws
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#f5576c', fontSize: '18px' }}>✓</span>
                Gaming clan tournament prizes
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🚀 How to Run Your Perfect Giveaway
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '30px',
          marginBottom: '40px'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '100px',
              height: '100px',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 25px',
              fontSize: '40px',
              color: 'white',
              fontWeight: 'bold',
              boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)'
            }}>
              1
            </div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: '#333'
            }}>
              Add Participants
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Enter contestant names, usernames, or entries into our <strong>giveaway name picker</strong>
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '100px',
              height: '100px',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 25px',
              fontSize: '40px',
              color: 'white',
              fontWeight: 'bold',
              boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)'
            }}>
              2
            </div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: '#333'
            }}>
              Spin Live
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Click spin and watch the excitement build as your audience sees the real-time selection
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '100px',
              height: '100px',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 25px',
              fontSize: '40px',
              color: 'white',
              fontWeight: 'bold',
              boxShadow: '0 4px 15px rgba(245, 87, 108, 0.3)'
            }}>
              3
            </div>
            <h3 style={{
              fontSize: '22px',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: '#333'
            }}>
              Celebrate Winner
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Enjoy the confetti celebration and announce your winner with complete confidence in the fairness
            </p>
          </div>
        </div>

        <div style={{
          backgroundColor: '#fff3cd',
          padding: '30px',
          borderRadius: '12px',
          border: '2px solid #ffeeba'
        }}>
          <h3 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#856404',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            💡 Pro Giveaway Tips
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '25px'
          }}>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '10px', color: '#856404' }}>Build Anticipation:</h4>
              <p style={{ fontSize: '15px', color: '#6c5ce7' }}>
                Announce the giveaway in advance and let participants watch the live <strong>contest spinner wheel</strong> in action
              </p>
            </div>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '10px', color: '#856404' }}>Screen Share:</h4>
              <p style={{ fontSize: '15px', color: '#6c5ce7' }}>
                Share your screen during live streams to show the spinning process for maximum transparency
              </p>
            </div>
            <div>
              <h4 style={{ fontWeight: 'bold', marginBottom: '10px', color: '#856404' }}>Multiple Rounds:</h4>
              <p style={{ fontSize: '15px', color: '#6c5ce7' }}>
                Run multiple prize tiers by removing winners and spinning again for additional prizes
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        textAlign: 'center',
        padding: '60px 30px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        borderRadius: '20px'
      }}>
        <h2 style={{
          fontSize: '42px',
          fontWeight: 'bold',
          marginBottom: '25px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          Ready to Host Amazing Giveaways? 🎉
        </h2>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          opacity: '0.95',
          maxWidth: '700px',
          margin: '0 auto 35px'
        }}>
          Join thousands of streamers, businesses, and event organizers using our <strong>free giveaway wheel spinner</strong> for fair and exciting contests.
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#764ba2',
            padding: '20px 45px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '22px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.3)'
          }}
        >
          Start Your Free Giveaway Now →
        </a>
        <div style={{
          marginTop: '25px',
          fontSize: '18px',
          opacity: '0.9'
        }}>
          No registration • No downloads • 100% Free • Works everywhere
        </div>
      </div>
    </div>
  );
};

export default Giveaway;